import { render, staticRenderFns } from "./EditChildren.vue?vue&type=template&id=00d3e0ce&scoped=true&"
import script from "./EditChildren.vue?vue&type=script&lang=js&"
export * from "./EditChildren.vue?vue&type=script&lang=js&"
import style0 from "./EditChildren.vue?vue&type=style&index=0&id=00d3e0ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d3e0ce",
  null
  
)

export default component.exports